export const COPPER_WIRE = "Copper Wire";

/**
 * Returns a new array with the "Copper Wire" option moved to the top while
 * preserving the relative order of all other items. Supports arrays of plain
 * commodity strings as well as arrays of objects that expose the commodity
 * name via the provided accessor (defaults to the `commodity` property).
 */
export function sortCommodityFirst(
  options: any[] | undefined | null,
  getName?: (item: any) => string | undefined,
): any[] {
  if (!Array.isArray(options)) return [];

  const nameOf = (item: any): string | undefined => {
    if (typeof item === "string") return item;
    if (getName) return getName(item);
    return item?.commodity;
  };

  return [...options].sort((a, b) => {
    const aRank = nameOf(a) === COPPER_WIRE ? 0 : 1;
    const bRank = nameOf(b) === COPPER_WIRE ? 0 : 1;
    return aRank - bRank;
  });
}

/**
 * Returns the commodity value that should be selected by default: "Copper Wire"
 * when it is present in the provided options, otherwise the first option.
 * Works with arrays of plain strings or `{ commodity }` objects.
 */
export function getDefaultCommodity(
  options: any[] | undefined | null,
  getName?: (item: any) => string | undefined,
): string | undefined {
  const first = sortCommodityFirst(options, getName)[0];
  if (first === undefined || first === null) return undefined;
  if (typeof first === "string") return first;
  if (getName) return getName(first);
  return first?.commodity;
}
